import React, { useState } from "react";
import UploadPDF from "../components/UploadPDF";
import { Box, Typography } from "@mui/material";
import PDFViewer from "../components/PDFViewer";
import { useTheme } from "@mui/material/styles";
import BillForm from "../components/BillForm";

const ViewFiles = ({ setShowForm, setUserInfo, showForm }) => {
  const theme = useTheme();

  return <UploadPDF setShowForm={setShowForm} setUserInfo={setUserInfo} showForm={showForm}/>;
};

export default ViewFiles;
